/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import HelpCenterSettingsWidgetConfigurationCustomizeAppQuery, {
	type HelpCenterSettingsWidgetConfigurationCustomizeAppQuery as HelpCenterSettingsWidgetConfigurationCustomizeAppQueryType,
} from './__generated__/HelpCenterSettingsWidgetConfigurationCustomizeAppQuery.graphql';

type CustomizeEntryPointComponent = EntryPointComponent<
	{
		page: HelpCenterSettingsWidgetConfigurationCustomizeAppQueryType;
	},
	{},
	{},
	{} | null
>;

export const customizeEntryPoint: EntryPoint<CustomizeEntryPointComponent, EntryPointRouteParams> =
	createEntryPoint({
		root: JSResourceForUserVisible<CustomizeEntryPointComponent>(
			/* webpackChunkName: "async-help-center-setting-widget-configuration-customize" */ './HelpCenterSettingsWidgetConfigurationCustomizeApp.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: ({
			context: {
				match: {
					params: { helpCenterId, widgetId },
				},
			},
			tenantContext: { cloudId, activationId },
		}: EntryPointRouteParams) => {
			return {
				queries: {
					page: {
						parameters: HelpCenterSettingsWidgetConfigurationCustomizeAppQuery,
						variables: {
							cloudId,
							helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
							widgetId: widgetId ?? '',
							isConsentFormEnabled: fg('csm_widget_consent_form'),
						},
						options: {
							fetchPolicy: 'store-or-network' as const,
						},
					},
				},
			};
		},
	});
